export enum UserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
}

export const TENANT_ADMIN_ROLES: readonly UserRole[] = [
  UserRole.OWNER,
  UserRole.ADMIN,
];

export const isTenantAdmin = (role: UserRole | undefined): boolean =>
  role !== undefined && TENANT_ADMIN_ROLES.includes(role);
